import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Cookies from '../providers/Cookies';

import { getIpdata } from '../api';

const defaultLocation = {
  callingCode: '1',
  countryCode: 'US',
  lat: 40.7643304,
  long: -73.9772046,
  isEU: false,
  isNonUS: true,
  loaded: true,
  loadedFromCookie: false,
};

export const fromCookies = () => {
  const result = Cookies.get('userLocation');
  if (result) {
    return { ...result, loaded: true, loadedFromCookie: true };
  }
  return { loaded: false, loadedFromCookie: false };
};

export const setLocation = (data) => {
  let coordinates = {};

  if (data?.latitude && data?.longitude) {
    coordinates = {
      lat: data.latitude,
      long: data.longitude,
    };
  }

  let callingCode = data.calling_code;
  if (/\D/.test(callingCode)) callingCode = '1';
  // eslint-disable-next-line camelcase
  const { country_iso_code: countryCode, is_in_eu } = data;
  // eslint-disable-next-line camelcase
  const isEU = is_in_eu || countryCode?.toLowerCase() === 'gb' || countryCode?.toLowerCase() === 'au';

  let isNonUS = true;
  if (countryCode) isNonUS = countryCode?.toLowerCase() !== 'us';

  const { success } = data;

  const newUserLocation = {
    ...coordinates,
    countryCode,
    isEU,
    isNonUS,
    callingCode,
  };

  return {
    ...newUserLocation, loaded: true, loadedFromCookie: false, success,
  };
};

const fetchIpdata = createAsyncThunk(
  'ipdata/fetchIpdataStatus',
  getIpdata
);

const ipdataSlice = createSlice({
  name: 'ipdata',
  initialState: fromCookies(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchIpdata.fulfilled, (state, action) => { Object.assign(state, setLocation(action.payload)); });
    // if fail, then returns default ny
    builder.addCase(fetchIpdata.rejected, (state) => { Object.assign(state, defaultLocation); });
  },
});

export { fetchIpdata };

export default ipdataSlice.reducer;
